<template>
    <div class="row mt-5">
        <form class="col-6 offset-3">
            <h4 class="card-title mb-4">{{ title }}</h4>
            <label class="file-import">
                <input ref="file" type="file" @change="onFileChange" />
                <img :src="require('@/assets/images/excel.svg')" />
                <span class="placeholder" v-if="!selectedFile">Cliquer ici pour choisir un fichier</span>
                <span class="placeholder filename" v-else>{{ selectedFile }}</span>
                <q-button @click="onFileUplaod" :loading="loading">{{ loading ? "En cours d'importation" : "Lancer l'importation" }}</q-button>
            </label>
        </form>
    </div>
</template>

<script>
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";

    export default {
        page: {
            title: "Importation les données",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: {
            PageHeader
        },
        data: () => ({
            title: "Importation les données",
            selectedFile: null,
            loading: false
        }),
        methods: {
            onFileChange(event) {
                this.selectedFile = event.target.files[0].name;
            },
            async onFileUplaod() {
                if (!this.selectedFile) return;
                try {
                    this.loading = true;
                    const formData = new FormData();
                    formData.append("file", this.$refs.file.files[0]);
                    await this.$axios.post("/data/import", formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    });
                    this.$refs.file.value = null;
                    this.selectedFile = null;
                } finally {
                    this.loading = false;
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .file-import {
        position: relative;
        width: 100%;
        height: 50px;
        background-color: rgba($primary, 0.2);
        border-radius: $border-radius;
        display: flex;
        align-items: center;
        margin-bottom: 0;
        padding-right: 150px;
    }

    .file-import input {
        display: none;
    }

    .file-import img {
        width: 60px;
        margin-right: 20px;
        border-right: 1px solid rgba($primary, 0.3);
    }

    .file-import .placeholder {
        flex: 1;
        overflow: hidden;
        color: rgba($primary, 0.75);
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .file-import .placeholder.filename {
        color: $dark;
    }

    .file-import .btn {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
    }
</style>
